import { makeObservableRowBase, RowBase } from 'shared/ui/TableNew/model/RowBase'
import { type IResponseContactUnlinked } from 'entities/Contacts/api/types'

export class RowContactUnlinked extends RowBase<IResponseContactUnlinked> {
  constructor(origin: IResponseContactUnlinked) {
    super(origin)

    makeObservableRowBase(this)
  }
}
